<template>

    <div class="drug-register-view view">
        <div class="panel" v-if="$store.state.user.role.permissions.includes('can_view_resident')"
            style="width: 100%;  box-sizing: border-box;">
            <div
                style="background-color: white; padding: 25px; padding-top: 0px; height: 85vh; box-shadow: 0px 0 5px -2px rgb(155, 155, 155); border-radius: 12px; border-top-right-radius: 0px;">
                <!-- HEADER ANF FILTER -->
                <div style="display: flex; flex-direction: column;">

                    <div v-if='accessFiles'
                        style="display: flex; flex-direction: column; align-items: flex-start; padding-top: 2em;">
                        <h3 style="color: black; text-align: left; margin: 0px 10px 0px 0px; padding: 20px;">
                            Search Files
                        </h3>
                        <div style="display: flex; justify-content: space-between; width: 100%; align-items: center;">
                            <div>
                                <!-- <Button @click="displayIHIHistoryModal = true"
                                    style="width: fit-content; margin-right: 1em;"
                                    class="outline-button p-button-outlined" label="StrongRoom AI Files" /> -->
                                <!-- <Button @click="displayIHIHistoryModal = true"
                                    style="width: fit-content; margin-right: 1em;"
                                    class="outline-button p-button-outlined" label="My Health Record Files" /> -->
                                <!-- <Button @click="displayIHIHistoryModal = true"
                                    style="width: fit-content; margin-right: 1em;"
                                    class="outline-button p-button-outlined" label="ECR Files" /> -->
                                <Button @click="displayIHIHistoryModal = true"
                                    style="width: fit-content; margin-right: 1em; background-color: #9F5CC0; color: white;"
                                    class="active-button p-button-outlined" label="My Health Record Files" />
                            </div>
                            <!-- <Button class="black-button" style="width: fit-content;"
                                label="Upload Resident Medication Chart" @click="uploadFile()" /> -->
                            <!-- <Button v-if="this.miniView" class="black-button"
                                style="width: fit-content; display: flex; align-items: center; gap: 8px;"
                                @click="openFileWindow()">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                                    <line x1="3" y1="9" x2="21" y2="9"></line>
                                    <line x1="9" y1="21" x2="9" y2="9"></line>
                                </svg>
                                <span>Open External Window View</span>
                            </Button> -->
                            <Button v-if="this.miniView" class="black-button"
                                style="width: fit-content; display: flex; align-items: center; gap: 8px;"
                                @click="openFileWindow()">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                                    <line x1="3" y1="9" x2="21" y2="9"></line>
                                    <line x1="9" y1="21" x2="9" y2="9"></line>
                                </svg>
                                <span>Open External Window View</span>
                            </Button>
                            <Button v-else class="black-button"
                                style="width: fit-content; display: flex; align-items: center; gap: 8px;"
                                @click="uploadFile()">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                    <polyline points="17 8 12 3 7 8"></polyline>
                                    <line x1="12" y1="3" x2="12" y2="15"></line>
                                </svg>
                                <span>Upload {{ $resident({ capitalize: true }) }} Medication Chart</span>
                            </Button>

                        </div>
                        <p>Please select an Item from list below to view file:</p>
                    </div>
                </div>

                <div v-if="accessFiles"
                    style="display: grid; grid-template-columns: 334px 5fr; margin-top: 10px; height: 90%">
                    <FileSearchBox @get-file="getFile" @get-view="getView" @remove-file="removeFile"
                        @search-file="searchFile" @select-file="selectFile" :files="files" :patient="this.patient"
                        :fileLoading="loading" />
                    <FileXmlView :xml="fileXml" :attachments="fileAttachments" />
                    <SignatureModal v-if="displaySignatureModal" :payload="payload" @close="close"
                        :endpoint="signature_endpoint" :reason="true" />
                </div>
                <div v-else-if="this.displayMyhealthRecordModal === true">
                    <MyHealthRecorModal @actionTitle="modalTitle" :accessCode="accessCodeStatus" :loading="loading"
                        @action="getFileAccess" @close="setAccessCodeModal" :errorMessage="mhrError" />
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import axios from 'axios';
const axiosCancelToken = axios.CancelToken
const source = axiosCancelToken.source();

// import SuccessModal from '@/components/modals/SuccessModal.vue';
import SignatureModal from '@/components/modals/SignatureModal.vue';
import FileSearchBox from '@/components/files/FileSearchBox.vue';
import FileXmlView from '@/components/files/FileXmlView.vue';
import MyHealthRecorModal from '../modals/MyHealthRecorModal.vue';
// import NodeService from '../../service/NodeService';

export default {
    props: ["patient", "miniView"],
    nodeService: null,
    components: {
        SignatureModal,
        FileSearchBox,
        FileXmlView,
        MyHealthRecorModal
    },
    data() {
        return {
            selectedFile: null,
            loading: false,
            mhrError: '',
            displayMyhealthRecordModal: false,
            accessCodeStatus: false,
            displaySuccessModal: false,
            successMessage: '',
            modalTitle: '',
            accessFiles: false,
            fileXml: '',
            // Other entries of the XDM package, so the viewer can resolve the
            // attachment links the CDA declares by filename.
            fileAttachments: [],
            files: [],
        }
    },
    methods: {
        openFileWindow() {
            window.open(this.fileXml);
        },
        setAccessCodeModal() {
            // this.accepted = true;
            console.log("setting access code control modal");
            this.displayMyhealthRecordModal = false;
            this.displaySuccessModal = false;
        },
        gainAccess(code) {
            // this.accepted = true;
            console.log("setting access code control modal");
            this.displayMyhealthRecordModal = !this.displayMyhealthRecordModal
        },
        // The MHR endpoints return a plain text body on failure, e.g.
        // "Error: Facility does not have HPI-O". Reading only .message meant
        // every one of those showed the same generic fallback instead of the
        // actual reason.
        mhrErrorMessage(err, fallback) {
            const data = err.response && err.response.data;

            if (typeof data === 'string' && data.trim()) {
                return data.replace(/^Error:\s*/, '');
            }
            if (data && data.message) {
                return data.message;
            }
            if (data && data.error && data.error.message) {
                return data.error.message;
            }
            return fallback;
        },
        getFileExist() {
            this.displayMyhealthRecordModal = true;
            this.loading = true;    
            // this.displaySuccessModal = true;
            // this.loading = true;
            this.$store.dispatch('getRefreshToken');
            // this.accessFiles = true;
            if (this.patient) {
                // Add new field to header without mutating the original
                const enhancedHeader = {
                    ...this.$store.state.header,
                    headers: {
                        ...this.$store.state.header.headers,
                        'Facility': this.patient.physical_location.location.facility.uuid
                    }
                };
                axios.get(`/mhr/patient/${this.patient.uuid}/exist`, enhancedHeader).then(res => {
                    console.log("Getting access to files ref:1 xxxxxx ...... ,", res);
                    // this.locations = res.data;
                    if (res.data.status === "true") {
                        if (res.data.access_code === "WithoutCode" || res.data.access_code === "AccessGranted") {
                            // this.loading= false;
                            // this.displaySuccessModal = false;
                            console.log("Getting access to files ref:2 ...... ,");
                            this.accessFiles = true;
                            this.displayMyhealthRecordModal = false;
                            this.loading = false;

                            // set default false to testing access code module TESTING ONLY ...
                            // this.accessFiles = false;
                            // this.loading = false;
                            // this.accessCodeStatus = true;
                        } else {
                            console.log("debugging ,", res.data.access_code);
                            console.log("Access Code Required ......");
                            this.accessFiles = false;
                            this.loading = false;
                            this.accessCodeStatus = true;
                        }
                    } else {
                        // else will be handler 206 HTTP code
                        // whether access_code required
                        console.log("Getting access to files ref:3 ...... ,");
                        //should set trigger access_code modules as well
                        this.accessFiles = false;
                        this.loading = false;
                        
                        // Set error message for Response Modal
                        if (res.data.messages && typeof res.data.messages === 'string') {
                            // Handle case where messages is a string (e.g., "PCEHR_ERROR_0004 - Authorisation denied")
                            this.mhrError = res.data.messages;
                        } else if (res.data.messages && res.data.messages.length > 0) {
                            // Handle case where messages is an array
                            this.mhrError = res.data.messages[0];
                        } else if (res.data.errors && res.data.errors.length > 0) {
                            this.mhrError = res.data.errors[0];
                        } else {
                            this.mhrError = "Patient doesn't have MHR, please check this patient IHI again";
                        }
                    }
                }).catch(err => {
                    console.log("Error catch /access ,", err);
                    if (err.response && err.response.data && typeof err.response.data === 'string' && err.response.data.includes('expired')) {
                        console.log('yes, it does include expired')
                        this.$router.push('/login');
                    } else {
                        // Set error message for Response Modal
                        this.mhrError = this.mhrErrorMessage(
                            err,
                            "Patient doesn't have MHR, please check this patient IHI again"
                        );
                        this.accessFiles = false;
                        this.loading = false;
                    }
                })
            } else {
                console.log("Error catch /access: failed to get this.patient");
                this.accessFiles = false;
            }
        },
        getFileAccess(access) {
            console.log("Getting access to files ref:0 ......", access);
            this.$store.dispatch('getRefreshToken');
            this.loading = true;
            if (this.patient) {
                const payload = {
                    access_code: access.access_code,
                    access_type: access.access_type
                };
                    // Add new field to header without mutating the original
                    const enhancedHeader = {
                    ...this.$store.state.header,
                    headers: {
                        ...this.$store.state.header.headers,
                        'Facility': this.patient.physical_location.location.facility.uuid
                    }
                };
                axios.post(`/mhr/patient/${this.patient.uuid}/access`, payload, enhancedHeader).then(res => {
                    console.log("Getting access to files ref:1 ...... ,", res);
                    // this.locations = res.data;
                    if (res.data.status === "true") {
                        if (res.data.access_code === "WithoutCode" || res.data.access_code === "AccessGranted") {
                            console.log("Getting access to files ref:2 ...... ,");
                            this.accessFiles = true;
                            this.loading = false;
                            this.displayMyhealthRecordModal = false;
                            // set default false to testing access code module
                            // this.accessFiles = false;
                        } else {
                            console.log("debugging ,", res.data.access_code);
                            this.accessFiles = false;
                            this.loading = false;
                            this.mhrError = res.data;
                        }
                    } else {
                        // else will be handler 206 HTTP code
                        // whether access_code required
                        console.log("Getting access to files ref:3 ...... ,");
                        //should set trigger access_code modules as well
                        this.accessFiles = false;
                        this.loading = false;
                        
                        if (res.data.messages && typeof res.data.messages === 'string') {
                            this.mhrError = res.data.messages;
                        } else if (res.data.messages && res.data.messages.length > 0) {
                            this.mhrError = res.data.messages[0];
                        } else if (res.data.errors && res.data.errors.length > 0) {
                            this.mhrError = res.data.errors[0];
                        } else {
                            this.mhrError = "Patient doesn't have MHR, please check this patient IHI again";
                        }
                    }
                }).catch(err => {
                    console.log("Error catch /access ,", err);
                    if (err.response && err.response.data && typeof err.response.data === 'string' && err.response.data.includes('expired')) {
                        console.log('yes, it does include expired')
                        this.$router.push('/login');
                    } else {
                        this.mhrError = this.mhrErrorMessage(
                            err,
                            "An error occurred while gaining access to My Health Record."
                        );
                    }
                    this.accessFiles = false;
                    this.loading = false;
                })
            } else {
                console.log("Error catch /access: failed to get this.patient");
                this.accessFiles = false;
                this.loading = false;
            }
        },
        getFile(file) {
            console.log("This is file type, ", file.type.identify);
            this.$store.dispatch('getRefreshToken');
            // this.fileXml = "123"
            console.log('triggering get files', file);
            this.fileXml = null;
            this.fileAttachments = [];
            if (this.accessFiles && file != null) {
                let req = {
                    type: file.type.identify,
                    document_id: file.documentId,
                    repository_id: file.repositoryUniqueId
                };
                // Add new field to header without mutating the original
                const enhancedHeader = {
                    ...this.$store.state.header,
                    headers: {
                        ...this.$store.state.header.headers,
                        'Facility': this.patient.physical_location.location.facility.uuid
                    }
                };
                console.log("this is req ", req);
                axios.post(`/mhr/patient/${this.patient.uuid}/file`, req, enhancedHeader).then(res => {
                    console.log("Getting to file ref:1 ...... ,", res.data);
                    // this.locations = res.data;
                    if (res.data.url !== null) {
                        // console.log("Getting access to files ref:2 ...... ,", res.data.xml);
                        // // this.accessFiles = true;
                        // this.fileXml = res.data.xml;

                        // this is really data
                        // console.log("Getting access to file ref:2 ...... ,", res.data);
                        // this.fileXml = res.data;
                        //this is testing
                        // Fetch CDA_ROOT.txt and set fileXml
                        console.log("this is path return ......", res.data);
                        this.fileAttachments = res.data.attachments || [];
                        this.fileXml = res.data.url;
                        // fetch(res.data)
                        //     .then(response => response.text())
                        //     .then(data => {
                        //         this.fileXml = data;
                        //     })
                        //     .catch(error => {
                        //         console.error('Error fetching CDA_ROOT.txt:', error);
                        //     });
                    } else {
                        // else will be handler 206 HTTP code
                        // whether access_code required
                        console.log("Getting access to files ref:3 ...... ,");
                        //should set trigger access_code modules as well
                        // this.accessFiles = false;
                    }
                }).catch(err => {
                    console.log("Error catch /file ,", err);
                    if (err.response && err.response.data && typeof err.response.data === 'string' && err.response.data.includes('expired')) {
                        console.log('yes, it does include expired')
                        this.$router.push('/login');
                    }
                })
            } else {
                console.log("Error catch /file: failed to get this.patient");
                this.accessFiles = false;
            }
        },
        removeFile(file, callback) {
            this.$store.dispatch('getRefreshToken');
            // this.fileXml = "123"
            console.log('triggering remove files', file);
            if (this.accessFiles && file != null) {
                let req = {
                    patient: {
                        ...this.patient,
                        address:
                        {
                            "street": "106 Barn Rvr",
                            "city": "Chahpingah",
                            "state": "QLD",
                            "post_code": "4610"
                        }
                    },
                    remove_document_id: file.documentId,
                    reasons: "Withdrawn"
                };
                // Add new field to header without mutating the original
                const enhancedHeader = {
                    ...this.$store.state.header,
                    headers: {
                        ...this.$store.state.header.headers,
                        'Content-Type': 'application/json',
                        'Facility': this.patient.physical_location.location.facility.uuid,
                    }
                };
                axios.delete(`/mhr/patient/${this.patient.uuid}/file`, {
                    ...enhancedHeader,
                    data: req
                }).then(res => {
                    console.log("this is removing file res: ...... ,", res);
                    this.displaySuccessModal = true;    
                    const successMsg = res.data && res.data.messages ? res.data.messages : "Document is Successfully Removed";
                    callback(null, successMsg);
                }).catch(err => {
                    console.log("Error catch /file ,", err);
                    let errorMsg = "An error occurred while removing the file.";
                    if (err.response && err.response.data) {
                        if (typeof err.response.data === 'object' && err.response.data.message) {
                            errorMsg = err.response.data.message;
                        } else if (typeof err.response.data === 'string') {
                            if (err.response.data.includes('expired')) {
                                console.log('yes, it does include expired')
                                this.$router.push('/login');
                                return;
                            }
                            errorMsg = err.response.data;
                        }
                    }
                    callback(errorMsg);
                })
            } else {
                console.log("Error catch /file: failed to get this.patient");
                this.accessFiles = false;
                callback("Error: failed to get patient or file.");
            }

        },
        selectFile(file) {
            this.selectedFile = file;
        },
        uploadFile() {
            // this.$emit('upload-file', this.selectedFile);
            this.$emit('upload-file', this.selectedFile, () => {
                console.log("upload is successfull");
                this.searchFile(); // Callback after removal is handled
            });
        },
        searchFile(filter) {
            this.loading = true;
            this.selectedFile = null;
            this.fileXml = '';
            this.fileAttachments = [];
            console.log("searching file .....")
            // search all files 
            if (this.patient) {
                //     let filter = {
                //     from: "",
                //     to: "",
                //     type: this.selectedOption, // this is name of selected document
                //     identify:this.searchType, // this is view or file
                //     class: "", // this is document class
                // };
                // Add new field to header without mutating the original
                const enhancedHeader = {
                    ...this.$store.state.header,
                    headers: {
                        ...this.$store.state.header.headers,
                        'Facility': this.patient.physical_location.location.facility.uuid
                    }
                };
                axios.post(`/mhr/patient/${this.patient.uuid}/list-files`, { filter }, enhancedHeader).then(res => {
                    console.log("searching files ref:1 ...... ,", res);
                    if (res.data.length !== 0) {
                        console.log("Getting files ref:2 ...... ,", res.data);
                        // this.files = res.data;
                        this.files = [...res.data];
                        // console.log("Debuggg this is files ,",this.files);
                    } else {
                        // else will be handler 206 HTTP code
                        // whether access_code required
                        console.log("searching files ref:3 ...... ,");
                        this.files = [];
                    }
                    this.loading = false;
                }).catch(err => {
                    console.log("Error catch /files ,", err);
                    if (err.response && err.response.data && typeof err.response.data === 'string' && err.response.data.includes('expired')) {
                        console.log('yes, it does include expired')
                        this.$router.push('/login');
                    }
                    this.loading = false;
                })
            } else {
                console.log("Error catch /files: failed to get this.patient");
                this.files = [];
                this.loading = false;
            }
        },
        getView(filter) {
            this.files = [];
            this.selectedFile = null;
            this.fileXml = '';
            this.fileAttachments = [];
            this.loading = true;
            console.log("getting view as document .....")
            if (this.patient) {
                const enhancedHeader = {
                    ...this.$store.state.header,
                    headers: {
                        ...this.$store.state.header.headers,
                        'Facility': this.patient.physical_location.location.facility.uuid
                    }
                };
                
                axios.post(`/mhr/patient/${this.patient.uuid}/list-files`, { filter: {} }, enhancedHeader).then(res => {
                    console.log("searching view files ref:1 ...... ,", res);
                    if (res.data && res.data.length !== 0) {
                        let targetName = filter.name || "";
                        let matchedFile = res.data.find(f => f.type && f.type.displayName && f.type.displayName.toLowerCase().includes(targetName.toLowerCase()));
                        
                        if (matchedFile) {
                            let req = {
                                document_id: matchedFile.documentId,
                                repository_id: matchedFile.repositoryUniqueId
                            };
                            axios.post(`/mhr/patient/${this.patient.uuid}/file`, req, enhancedHeader).then(fileRes => {
                                if (fileRes.data && fileRes.data.url) {
                                    this.fileAttachments = fileRes.data.attachments || [];
                                    this.fileXml = fileRes.data.url;
                                }
                                this.loading = false;
                            }).catch(err => {
                                console.log("Error fetching view file content", err);
                                this.loading = false;
                            });
                        } else {
                            console.log("No matching view document found");
                            this.loading = false;
                        }
                    } else {
                        this.loading = false;
                    }
                }).catch(err => {
                    console.log("Error catch /list-files ,", err);
                    if (err.response && err.response.data && typeof err.response.data === 'string' && err.response.data.includes('expired')) {
                        console.log('yes, it does include expired')
                        this.$router.push('/login');
                    }
                    this.loading = false;
                })
            } else {
                console.log("Error catch /files: failed to get this.patient");
                this.files = [];
                this.loading = false;
            }
        },
    },
    mounted() {
        this.getFileExist();
    },
    unmounted() {
        this.selectedFile = null;
    },
    computed: {
        getPatients() {
            return this.$store.getters.getPatients;
        },
    }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/main.scss";

.select-filters-container {
    p {
        font-size: 15px;
    }
}

.p-dropdown.admin-rooms-dropdown {
    background: #F3F4F4;
    border: none;
}

.admin-chart-form {
    background-color: white;
    border-radius: 12px;

}

.admin-chart-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;

    h4 {
        color: $strongblue;
    }

    border-bottom: 2px solid $bordergrey;
    width: 100%;
}

.admin-chart-drug-list-table {
    padding: 0 20px;

    td {
        padding: 0;
    }
}

.pi-info-circle {
    color: $strongblue;
    border-radius: 50%;
    margin: 0;
    padding: 0;
    font-size: 1.3em !important;
    font-weight: bold;
    cursor: pointer;
}

.admin-chart-signature-button {
    background-color: $strongblue;
    color: white;
    height: 27px;
    font-weight: bold;
    margin-left: 10px;

    p {
        margin: 0;
        padding: 0;
    }
}

.doc-select-container {
    select {
        background-image: url("data:image/svg+xml;utf8,<svg fill='white' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>") !important;
    }
}

.completed-chart-text {
    color: white;
    font-weight: 500;
    margin: 0;
    font-size: 14.5px;
    padding: 0 10px;
    text-align: left
}

.completed-chart-text:first-of-type {
    margin-top: 10px;
}

.completed-chart-text:last-of-type {
    margin-bottom: 10px;
}
</style>